import React, { FunctionComponent } from 'react';

import { InsuredItem, SingleFieldStepProps } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

export const STATE_KEY = 'propertyUsedForBusiness';

type MarketingConsentStepProps = Pick<
  SingleFieldStepProps<string>,
  'defaultStateValue' | 'onNext' | 'helpText'
> & { insuredItem: InsuredItem };

const PropertyUsedForBusinessStep: FunctionComponent<MarketingConsentStepProps> = ({
  defaultStateValue,
  onNext,
  insuredItem,
  helpText,
}) => (
  <SingleYesNoStep
    question={`Is any part of the ${insuredItem} used for business purposes?`}
    helpText={helpText}
    stateKey={STATE_KEY}
    defaultStateValue={defaultStateValue}
    onNext={onNext}
  />
);

export default PropertyUsedForBusinessStep;
